export const OUTREACH_STATUSES = Object.freeze({
  LIVE: "live",
  PILOT: "pilot",
  PLANNED: "planned",
});

export const outreachChannels = Object.freeze([
  { id: "whatsapp", label: "WhatsApp", status: OUTREACH_STATUSES.PLANNED },
  { id: "email", label: "Email", status: OUTREACH_STATUSES.PLANNED },
  { id: "linkedin", label: "LinkedIn", status: OUTREACH_STATUSES.PLANNED },
]);

export function getOutreachLabel(channel) {
  if (channel.status === OUTREACH_STATUSES.LIVE) return `${channel.label} outreach`;
  if (channel.status === OUTREACH_STATUSES.PILOT) return `${channel.label} outreach — Pilot`;
  return `${channel.label} outreach — Coming soon`;
}

export const allOutreachChannelsPlanned = outreachChannels.every(
  (channel) => channel.status === OUTREACH_STATUSES.PLANNED,
);
